import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Channel } from '@tokeet-frontend/tv3-platform'
import { SaveForm } from '@tokeet-frontend/tv3-platform'
import { switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { ChannelHelperService } from '../../channel-helper.service'

export interface SelectChannelAccountDialogConfig {
  title?: string
  placeholder?: string
  help?: string
  buttonIcon?: string
  buttonText?: string
  channel: Channel
  entityName?: string
}

@Component({
  selector: 'app-select-channel-account-dialog',
  host: { class: 'modal-content' },
  templateUrl: './select-channel-account-dialog.component.html',
  styleUrls: ['./select-channel-account-dialog.component.scss'],
})
export class SelectChannelAccountDialogComponent implements OnInit {
  config = {
    title: $localize`Select Accommodation ID`,
    placeholder: $localize`Select Accommodation ID`,
    help: $localize`Please select one accommodation ID you want to disconnect from above list.`,
    buttonText: $localize`Select`,
    entityName: $localize`Accommodation ID`,
  } as SelectChannelAccountDialogConfig

  form = this.fb.group({
    account: [undefined, [Validators.required]],
  })

  accounts$ = of(this.data.config.channel).pipe(
    switchMap((channel) => this.channelHelperService.getChannelAccounts(channel))
  )

  constructor(
    public dialogRef: MatDialogRef<SelectChannelAccountDialogComponent>,
    private fb: FormBuilder,
    private channelHelperService: ChannelHelperService,
    @Inject(MAT_DIALOG_DATA) public data: { config: SelectChannelAccountDialogConfig }
  ) {}

  ngOnInit() {
    this.config = { ...this.config, ...this.data.config }
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  save(form: FormGroup) {
    const formValues = this.form.getRawValue()
    this.dialogRef.close(formValues)
  }
}
